import { Box, Grid, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const preGranteesOverview =`Dear Colleague,

Here you will be able to see all current active grantees from your institution (in both programs) and additional detailed information and reports.

For each GIF grantee you can see the following information: Name, Email address, the Application title & number, the PDF and the Grant number.
In addition, for each GIF grantee you will find the Total Approved Budget for the duration of the grant,
and the payments transferred to this grantee so far (Actual Payments).

Under reports for each grantee you will find:
·       Financial Status which includes data summarizing the budget and the expenditures as they are recorded in the GIF system at the time of issuing the report.
·       Grant Status - which includes all the relevant data regarding the grant.

For your convenience you may use the Notes to write comments to yourself.
A dialogue box allowing you to write short messages to the GIF and vice versa.
Obviously this does not replace the regular communications by emails and telephone calls BUT it serves as an additional real time communication with the GIF.

We hope you will find this useful and user friendly.

As always, when ever needed, do not hesitate to contact us at: finance@gif.org.il

Thank you for your cooperation,


GIF Team`


const useStyles = makeStyles((theme) => ({
  infoIcon: {
    marginLeft: 5,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
}));


export default function Overview() {
  const classes = useStyles();

  return (
    <Grid container>
    <Grid item xs={12}>
      <Box className={classes.header}>
        <Typography variant="subtitle2">Grants Overview</Typography>
        <InfoOutlinedIcon className={classes.infoIcon} color="primary" />
      </Box>
    </Grid>
    <Grid item xs={12}>
      <pre style={{ fontFamily: "inherit", fontSize: 14 }}>
        {preGranteesOverview}
      </pre>
    </Grid>
    </Grid>
  );
}
